<template>
  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap" rel="stylesheet">

  <div id="app">
    <Header v-if="!isPortalRoute" />
    <router-view />
    <Footer v-if="!isPortalRoute" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

const route = useRoute()

// Hide header and footer for portal and flyer routes
const isPortalRoute = computed(() => {
  return route.path.startsWith('/portal') || route.path.startsWith('/flyers')
})
</script>

<style>
/* CSS Variables for consistent theming */
:root {
  --primary-color: #2c4a6b;
  --secondary-color: #3ba3d1;
  --accent-color: #e94f3a;
  --accent-yellow: #f5b938;
  --dark-bg: #1f3447;
  --light-bg: #f5f7fa;
  --text-dark: #333333;
  --text-light: #666666;
  --white: #ffffff;
  --gear-gray: #a8b1bb;
}

/* Dark mode variables */
.dark-mode {
  --primary-color: #4a7099;
  --secondary-color: #5bb3e1;
  --dark-bg: #0d1117;
  --light-bg: #161b22;
  --text-dark: #e6edf3;
  --text-light: #8b949e;
  --white: #0d1117;
  --gear-gray: #6e7681;
}

.dark-mode body {
  background: var(--dark-bg);
  color: var(--text-dark);
}

/* Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: var(--text-dark);
  background: var(--white);
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Poppins', sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--white);
}

#app > main {
  flex: 1;
}
</style>
